export default __webpack_public_path__ + "static/media/level-7-bg.3e14b937.png";